import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../../style/datePicker.css"
import {submitDegree, updateDegree} from "../../../services/degree/degree";
import {DegreeContext} from "./degree_context";

export function DegreeForm() {

  const {modalOpen, setModalOpen, degree, setDegree, setLastDataRefresh} = useContext(DegreeContext);

  const handleOpen = () => setModalOpen(!modalOpen);

  const [id, setId] = useState(degree?.id ?? null)
  const [title, setTitle] = useState(degree?.title ?? "")
  const [description, setDescription] = useState(degree?.description ?? "");
  const [orderBy, setOrderBy] = useState(degree?.order_by ?? null);
  const [status, setStatus] = useState(degree?.status === 'enable')

  useEffect(() => {
    setId(degree?.id ?? null);
    setTitle(degree?.title ?? "");
    setDescription(degree?.description ?? "");
    setOrderBy(degree?.order_by ?? "");
    setStatus(degree?.status === 'enable');
  }, [degree]);

  const save = async () => {
    const data = {
      title: title,
      description: description,
      order_by: parseInt(orderBy),
      status: status ? "enable" : "disable"
    };
    let result;

    if (!id) {
      result = await submitDegree(data);
    } else {
      data["id"] = degree.id;
      result = await updateDegree(data);
    }

    if (result.status === 200) {
      setDegree({})
      setLastDataRefresh(Date.now());
      handleOpen();
    }
  };

  return (
    <>
      <Dialog open={modalOpen} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <Input variant="standard"
                   value={title}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setTitle(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={description}
                   label="توضیحات"
                   placeholder="توضیحات"
                   onChange={(e) => {
                     setDescription(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={orderBy}
                   label={Dict('order_by')}
                   placeholder={Dict('order_by')}
                   type="number"
                   min="0"
                   onChange={(e) => {
                     setOrderBy(e.target.value)
                   }}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}